/**
 * What the multi-promo modal's "Apply" button should do, given the current state.
 *
 * A logged-out customer must sign in first: `applyPromoCode` only flips an internal
 * `showLoginPrompt` flag that nothing renders, so calling it from the modal looked like
 * "nothing happens" on Apply (founder report 2026-08-04). Resolve to `login` instead so the
 * modal opens the login modal — the same behaviour as the deals-card path.
 */
export type PromoApplyAction = 'apply' | 'login' | 'noop';

export function resolvePromoApplyAction(params: { hasCode: boolean; isLoggedIn: boolean }): PromoApplyAction {
  if (!params.hasCode) {
    return 'noop';
  }

  if (!params.isLoggedIn) {
    return 'login';
  }

  return 'apply';
}
